

import React, { useState } from 'react';

import { 
    DashboardLayout, GeneralTable, Button, SubmenuTooltip, MoreButton,
    AlertMessage, Toaster 
} from "components";
import UserUpdate from './userUpdate/UserUpdate';

import ic_add_new_user from 'assets/images/ic_add_new_user.svg';
import ic_delete from 'assets/images/ic_delete_invoices.svg';

import { useAlertMessage, useUserGroup, useDeleteUser } from "./hooks";
import { tableData, userListColumns } from "./data";
import { func_validation } from 'functions';

import 'assets/scss/distributorPortal/modules/userManagement/userList.scss';



export function UserListPresentation(props) {
    // Props
    const { 
        getUserList_requesting, 

        getUserGroupList_requesting,
        userGroupList,

        isUserRecordUpdatedSuccessfully,
    } = props;
    

    // States

    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedUserDetail, setSelectedUserDetail] = useState("");
    const [selectedUserGroupIndexList, setSelectedUserGroupIndexList] = useState();

    const [isFormVisible, setIsFormVisible] = useState(false);

    const [
        alertMsg, setAlertMsg,
        isAlertMsgVisible, setIsAlertMsgVisible
    ] = useAlertMessage(props);

    const {
        userGroupLabels,
        modalDisplay: userGroupModal,
        setIsModalVisible_userGroup
    } = useUserGroup({
        ...props,
        selectedUserDetail,
        selectedUserGroupIndexList
    });

    const {
        userList_formatted,
        totalRecords
    } = tableData(props);

    const {
        modalDisplay: deleteUserModal,
        setIsModalVisible_deleteUser
    } = useDeleteUser({
        ...props,
        setAlertMsg,
        selectedUsers
    });

    function handleFormVisibility_addUser() {
        setIsFormVisible(true);
    }

    return (
        <div className={"userList"}>
            {/* Delete Alert */}
            {deleteUserModal}

            {/* User Group */}
            {userGroupModal}

            {(!isFormVisible)? (
                <DashboardLayout
                    headerTitle={"User Management"}

                    bodyClassName={"userList-body"}
                    body={(
                        <GeneralTable
                            className={"userList-table"}
                            columns={userListColumns.getColumns({
                                ...props,
                                setIsModalVisible_userGroup,
                                setSelectedUserGroupIndexList, setSelectedUserDetail,
                            })}
                            data={userList_formatted}
                            minRows={10}

                            getTableData={props.getList}

                            isTableRefreshRequired={isUserRecordUpdatedSuccessfully}

                            outerTableHeader={(outerTableHeader_props) => {
                                const { selectedRows: selectedUsers } = outerTableHeader_props;

                                return (
                                    <React.Fragment>
                                        {/* Alert Error Messages */}
                                        <AlertMessage
                                            message={alertMsg}
                                            isVisible={isAlertMsgVisible}
                                            toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
                                        />

                                        <div className={"userList-table-header d-flex align-items-center justify-content-between "}>
                                            <div className={"userList-tableHeader-title tableHeaderTitle "}>
                                                User List
                                            </div>

                                            <div className={"userList-tableHeader-action d-flex align-items-center"}>
                                                
                                                <div className={"userList-tableHeaderAction-mainActionWrapper"}>
                                                    <Button
                                                        className={"userList-tableHeaderAction-mainAction tableHeaderButtonPadding d-flex align-items-center"}
                                                        handleOnClick={() => { handleFormVisibility_addUser(); }}

                                                        isDisabled={false && func_validation.isUserAccessDenied(props, "Dealer_User_Create")}
                                                        isDecoration_primaryTransparent
                                                    >
                                                        <React.Fragment>
                                                            <img
                                                                className={"userList-tableHeaderAction-icon"}
                                                                src={ic_add_new_user}
                                                                alt={"Add user icon"}
                                                            />

                                                            <span className={"userList-tableHeaderAction-text tableHeaderButtonText "}>Add New User</span>
                                                        </React.Fragment>
                                                    </Button>
                                                </div>

                                                <SubmenuTooltip
                                                    buttonClassName={""}
                                                    menuItems={
                                                        [
                                                            {
                                                                icon: ic_delete,
                                                                label: "Remove Group",
                                                                isDisabled: false && func_validation.isUserAccessDenied(props, "Dealer_User_Delete"),
                                                                onClick: () => { 
                                                                    if (func_validation.isArrayNotEmpty(selectedUsers)) {
                                                                        setIsModalVisible_deleteUser(true);
                                                                        setSelectedUsers(selectedUsers);
                                                                    }
                                                                    else {
                                                                        Toaster({
                                                                            type: "info",
                                                                            msg: "Please select at least 1 user.",
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                        ]
                                                    }
                                                >
                                                    <MoreButton
                                                        className={"userList-tableHeaderAction-moreActions"}
                                                        iconClassName={"userList-tableHeaderMoreAction-icon"}
                                                    />
                                                </SubmenuTooltip>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                );
                            }}

                            isTableDataLoading={getUserList_requesting}

                            isUsingPagination
                            totalRecords={totalRecords}

                            isCheckboxRequired isCheckboxColumnFirst
                            isExpanderRequired={true || func_validation.isUserAccessGranted(props, "Dealer_UserGroupMapping_View")}
                            isColumnResizeable isRowExpanderColumnFirst
                            isTableOddRowsDarken
                        />
                    )}
                />
            ):""}

            {/* Form */}
            {isFormVisible? (
                <UserUpdate
                    updateParentState_visiblity={setIsFormVisible}

                    userGroupList={userGroupList}
                    getUserGroupList_requesting={getUserGroupList_requesting}
                    userGroupLabels={userGroupLabels}
                />
            ):""}
        </div>
    );
}